(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ygiafy-beauty"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ygiafy-beauty')) {
    customElements.define('ygiafy-beauty', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const date = this.querySelector('[data-yb-date]');
        if (date) {
          const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'Asia/Nicosia',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
          const part = name => parts.find(p => p.type === name).value;
          date.min = `${part('year')}-${part('month')}-${part('day')}`;
          date.addEventListener('input', () => date.setCustomValidity(date.value && date.value < date.min ? date.dataset.ybPast : ''));
        }
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-yb-service]');
          if (!link) return;
          const select = this.querySelector('[data-yb-select]');
          const option = Array.from(select.options).find(item => item.dataset.ybId === link.dataset.ybService);
          if (option) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', {bubbles:true}));
            requestAnimationFrame(() => select.focus({preventScroll:true}));
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
